import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import { displayIcon } from "variables/icons";
import Holidays from "./index";
import ViewHoliday from "./view";
import EditHoliday from "./edit";
import { MODULE_HOLIDAYS } from "variables/constants";

const holidaysRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Holidays",
		basePath: "holidays",
		mainComponent: <Holidays />,
	    layout: "/console",	   
	    icon: displayIcon('Calendar1', 'icon-item'),
	    subTitle:"Holiday",
	    viewComponent: <ViewHoliday />,
	    createComponent: <EditHoliday />,
	    editComponent: <EditHoliday />,
		level:3,
		moduleId: MODULE_HOLIDAYS,
	})
]

export default holidaysRoutes;